import { CircularProgress, IconButton } from "@mui/material";
import { IconFileDownload } from "@svg/index";

const DownloadButton = ({
    isLoading,
    doFetchAndDownload
}: {
    isLoading: boolean,
    doFetchAndDownload: () => void
}) => (
    <IconButton
        onClick={() => doFetchAndDownload()}
        disabled={isLoading}
    >
        {isLoading ? (
            <CircularProgress size={20} />
        ) : (
            <IconFileDownload />
        )}
    </IconButton>
);

export default DownloadButton
